###
# Компонент кнопки с лоадером
#
# Параметры:
#   text
#   style
#   size
#   action
#   isLoading
####
App.SmButtonComponent = Em.Component.extend [
  Em.I18n.TranslateableAttributes,
  Em.I18n.TranslateableProperties
]...,
  tagName: 'button'
  classNames: ['sm-button']
  classNameBindings: ['style', 'size', 'isLoading', 'type']
  attributeBindings: ['disabled','data-clipboard-text']

  disabled: (->
    if @get('isLoading') then true
    else null
  ).property('isLoading')

  onLoadingStateChange: (->
    return if not @get('isLoading')?

    if @get('isLoading')
      @$()?.addClass(@get('animation'))
    else
      @$()?.removeClass(@get('animation'))
  ).observes('isLoading').on('didInsertElement')

  click: ->
    secondArgument = @get('secondArgument')
    secondArgument = @ if secondArgument == '@'

    @sendAction 'action',
      @get('firstArgument'),
      secondArgument
